import { Route, Routes } from "react-router-dom";
import PaymentIn from "../ReceiptAndPaymentOut/Table/PaymentIn";
import ResourceNotFound from "../../../Common/ResourceNotFound";
// import { ItemType } from "../../Services/ItemsService";
import LedgerTable from "../../Master/Ledger/LedgerTable";
import { SearchLedgerByGroupsTypes } from "../../../Services/LedgerService";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../../Users/Roles/UserSecurityFind";
import { useClient } from "../../../Context/ClientContext";
import { useUser } from "../../../../Context/UserContext";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../../Context/RoleContext";
import { SettingsSections } from "../../../Services/SettingService";
import SalesInvoiceAndPurchaseBillGraph from "../InvoiceAndPurchaseBill/Table/SalesInvoiceAndPurchaseBillGraph";
import SalesAndPurchaseOrderGraph from "../Order/Table/SalesAndPurchaseOrderGraph";
import ProformaInvoiceAndEstimateGraph from "../ProformaInvoiceAndEstimate/Table/ProformaInvoiceAndEstimateGraph";
import CreditAndDebitNotesTable from "../CreditAndDebitNote/Table/CreditAndDebitNotesTable";
import { Voucher_Type } from "../../../Services/VoucherServices";

const SalesNestedRoute = () => {
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  return (
    <Routes>
      <Route
        path="/invoices"
        element={
          findUserPremission(
            ["Voucher.Sales.1.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesInvoiceAndPurchaseBillGraph
              voucherType={Voucher_Type.SalesVoucher}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/proformaInvoices"
        element={
          findUserPremission(
            ["Voucher.Sales.2.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.PInvoice],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <ProformaInvoiceAndEstimateGraph />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* <Route path={"/"} element={<SubSaleInvoice />} /> */}
      <Route
        path="/creditNotes"
        element={
          findUserPremission(
            ["Voucher.Sales.3.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.CrNote],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <CreditAndDebitNotesTable />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/receipts"
        element={
          findUserPremission(
            ["Voucher.Sales.5.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Receipt],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <PaymentIn />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/estimate"
        element={
          findUserPremission(
            ["Voucher.Sales.4.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Quotation],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <ProformaInvoiceAndEstimateGraph />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/order"
        element={
          findUserPremission(
            ["Voucher.Sales.6.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.SOrder],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesAndPurchaseOrderGraph />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      <Route
        path="/customers"
        element={
          findUserOnlyOnePremission(
            "Master.Ledger.Customer.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <LedgerTable
              ledgerByGroupsType={SearchLedgerByGroupsTypes.DebtorsOnly}
              showName={"Customer"}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* <Route path="/deliveryChallan" element={<DeliveryChallan />} /> */}

      {/* <Route
        path="/items"
        element={
          findUserOnlyOnePremission(
            "Master.Item.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <Items itemPage={ItemType.SalesItems} />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      /> */}

      <Route path="*" element={<ResourceNotFound pageHeight="100%" />} />
    </Routes>
  );
};

export default SalesNestedRoute;
